<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
    </div>
    <div class="p-col-12 p-sm-12 p-md-8 p-lg-6 p-xl-4">
      <Message v-if="flash.message" :severity="flash.class">{{ flash.message }}</Message>
      <div class="card p-fluid">
        <h3>Change Password</h3>
        <div class="p-field">
          <label>Current Password</label>
          <Password v-model="input.oldPassword.value" name="oldPassword" :toggleMask="true" :feedback="false" v-bind:class="{ 'p-error': input.oldPassword.errMsg }" :required="true" />
          <small v-if="input.oldPassword.errMsg" class="p-error">{{ input.oldPassword.errMsg }}</small>
        </div>
        <div class="p-field">
          <label>New Password</label>
          <Password v-model="input.newPassword.value" name="newPassword" :toggleMask="true" :feedback="false" v-bind:class="{ 'p-error': input.newPassword.errMsg }" :required="true" />
          <small v-if="input.newPassword.errMsg" class="p-error">{{ input.newPassword.errMsg }}</small>
        </div>
        <div class="p-field">
          <label>Confirm New Password</label>
          <Password v-model="input.confirmNewPassword.value" name="confirmNewPassword" :toggleMask="true" :feedback="false" v-bind:class="{ 'p-error': input.confirmNewPassword.errMsg }" :required="true" />
          <small v-if="input.confirmNewPassword.errMsg" class="p-error">{{ input.confirmNewPassword.errMsg }}</small>
        </div>
        <br/>
        <Button label="Submit" class="p-mr-2 p-mb-2" @click="onSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
import { changePassword } from '@/api/auth'

export default {
  name: "ChangePassword",

  data() {
    return {
      breadcrumbHome: { icon: 'pi pi-home', to: { name: 'dashboard' } },
      breadcrumbItems: [
        { label:'User Profile', to: { name: 'profile.detail' } },
        { label:'Change Password', to: this.$route.path }
      ],
      flash: {
        message: '',
        class: ''
      },
      input: {
        oldPassword: {
          value: '',
          errMsg: ''
        },
        newPassword: {
          value: '',
          errMsg: ''
        },
        confirmNewPassword: {
          value: '',
          errMsg: ''
        }
      }
    }
  },
  methods: {
    onSubmit() {
      this.flash.class = null
      this.flash.message = null

      // Form Validation
      let doSubmit = true
      this.input.oldPassword.errMsg = null
      this.input.newPassword.errMsg = null
      this.input.confirmNewPassword.errMsg = null

      if (this.input.oldPassword.value == "" || this.input.oldPassword.value == null) {
        doSubmit = false
        this.input.oldPassword.errMsg = "Current Password must not be empty"
      }

      if (this.input.newPassword.value == "" || this.input.newPassword.value == null) {
        doSubmit = false
        this.input.newPassword.errMsg = "New Password must not be empty"
      }

      if (this.input.confirmNewPassword.value == "" || this.input.confirmNewPassword.value == null) {
        doSubmit = false
        this.input.confirmNewPassword.errMsg = "Confirm New Password must not be empty"
      } else if (this.input.newPassword.value != this.input.confirmNewPassword.value) {
        doSubmit = false
        this.input.confirmNewPassword.errMsg = "Confirm New Password must match with New Password"
      }

      // Submit
      if (doSubmit) {
        let newPwdObj = {
          oldPassword: this.input.oldPassword.value,
          newPassword: this.input.newPassword.value,
        }

        try {
          changePassword(newPwdObj)
            .then((res) => {
              if (res.data.status) {
                // this.$session.destroy()

                this.$toast.add({severity:'success', summary: 'Success', detail: res.data.message, life: 5000})
                this.$session.flash.set("flash-class", "success")
                this.$session.flash.set("flash-message", "Password changed successfully")

                this.$router.push({ name: "login" })
              } else {
                this.$toast.add({severity:'error', summary: 'Error', detail: res.data.message, life: 5000})
                this.flash.class = "error"
                this.flash.message = res.data.message
              }
            })
            .catch((e) => {
              if(e.response.status && e.response.status == 422) {
                this.flash.message = e.response.data.message

                if(e.response.data.errors) {
                  let errObj = e.response.data.errors
                  this.input.oldPassword.errMsg = errObj.old_password ? errObj.old_password[0] : null
                  this.input.newPassword.errMsg = errObj.new_password ? errObj.new_password[0] : null
                }
              } else {
                this.flash.message = "Password failed to changed due to network error."
              }

              // this.$toast.add({severity:'error', summary: 'Error', detail: "Password failed to changed due to network error.", life: 5000})
              this.flash.class = "error"
            });
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
